<template>
	<div class="favorite-lottery-card-wrap">
		<div class="favorite-lottery-card">
			<el-card class="box-card">
				<div class="header">
					<span><img src="@/static/img/icon/favorite-star.png" alt="我的收藏" />我的收藏</span>
				</div>
				<div class="list-item-box">
					<div v-for="item in userFavoritesLotteryList" :key="item.LgId" class="list-item">
						<div class="lottery-name">
							<a @click="!isEdit && toGame(item)">{{ item.Name }}</a>
						</div>
						<div class="lottery-time" v-show="!isEdit">
							<issueInfo :LgId="item.LgId" v-slot:default="issue">
								<countDown :time="issue.countDown" @upTimeData="issue.upTimeData" :customStyle="true" />
							</issueInfo>
						</div>
						<div v-show="isEdit">
							<el-button
								type="primary"
								icon="el-icon-delete"
								circle
								size="mini"
								@click="deleteUserFavoritesLottery(item.LgId)"
							/>
						</div>
					</div>
					<div v-if="listIsEmpty" class="list-item list-empty">
						<div><i class="el-icon-star-off" /> 暂无收藏!</div>
					</div>
				</div>
				<div v-if="!listIsEmpty" class="list-item bottom-operation">
					<div class="btn" v-show="!isEdit" @click="isEdit = !isEdit">编辑</div>
					<div class="btn" v-show="isEdit" @click="isEdit = !isEdit">完成</div>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
import { game } from "../../mixins/game";
import countDown from "../common/countDown";
import issueInfo from "../common/issueInfo";

export default {
	mixins: [game],
	name: "favoriteList",
	components: { countDown, issueInfo },
	data: function () {
		return {
			isEdit: false, // 是否点击下方操作
		};
	},
	computed: {
		userFavoritesLotteryList() {
			return this.$store.state.userFavoritesLotteryList; // 用户收藏彩种集合
		},
		listIsEmpty() {
			return this.$store.state.userFavoritesLotteryList.length === 0;
		},
	},
	beforeUpdate() {
		// 列表空的时候退出"编辑模式"
		if (this.listIsEmpty) {
			this.isEdit = false;
		}
	},
};
</script>

<style lang="scss">
//卡片定位相关
.favorite-lottery-card-wrap {
	position: relative;
	/*需要固定时从外部传入 class="fixed-left"*/
	&.fixed-left {
		.favorite-lottery-card {
			position: absolute;
			top: 0;
			left: 0;
			transform: translateX(calc(-100% - 10px));
			.header {
				background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);
				font-size: 14px;
				color: #fff;
				font-weight: normal;
				padding: 8px 10px;
				span {
					display: flex;
					align-items: center;
				}
			}
		}
	}
}

//卡片实际样式
.favorite-lottery-card {
	width: 180px;
	font-size: 14px;
	color: #333333;

	.box-card {
		border-radius: 10px;
		border: none;

		.el-card__body {
			position: relative;
			padding: 0;

			.list-item-box {
				max-height: 410px;
				overflow-y: auto;
				.lottery-name {
					a {
						color: #555;
						font-size: 13px;
					}
				}
			}

			.list-item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 20px 10px;

				&.list-empty {
					justify-content: center;
				}
				&.bottom-operation {
					justify-content: center;
					padding: 14px 0;
					border-top: 1px solid #eee;
					border-image: linear-gradient(to right, transparent 0%, #eee 50%, transparent);
					border-image-slice: 1;
					.btn {
						cursor: pointer;
						display: block;
						padding: 7px 16px;
						border-radius: 6px;
						background-image: linear-gradient(to top, #ccc, #eee);
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/favoriteList.vue